import { Component, EventEmitter, Output } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { Settings } from '../../lib/app.constant';

@Component({
  selector: 'app-share-email',
  standalone: false,
  templateUrl: './share-email.component.html',
  styleUrl: './share-email.component.scss'
})
export class ShareEmailComponent {
  EmailReplyForm = new FormGroup({
    to: new FormControl(null, [Validators.required,this.multipleEmailsValidator()]),
    cc: new FormControl(null,this.multipleEmailsValidator()),
    subject: new FormControl(null, [Validators.pattern(Settings.RegexPattern.whiteSpace)]),
    body: new FormControl(null, [this.whitespaceValidator()])
  });
  editorModules = {
    toolbar: [
      ['bold', 'italic', 'underline', 'strike'],        // toggled buttons        
      [{ 'list': 'ordered'}, { 'list': 'bullet' }],// custom dropdown
      [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
    ]
  };
  @Output() resetEmailData: EventEmitter<void>=new EventEmitter<void>();
  @Output() sendEmailData: EventEmitter<any>=new EventEmitter<void>();
  resetReplyForm(){
    this.EmailReplyForm.reset();
    this.resetEmailData.emit()
  }
  onClickSend(){
   this.sendEmailData.emit(this.EmailReplyForm.value)
  }

  multipleEmailsValidator(): ValidatorFn {
    return (control: FormControl): { [key: string]: any } | null => {
      const emails: string = control.value;
      if (emails && emails?.length > 0) {
        const emailArray: string[] = emails?.split(',').map(email => email?.trim());
        const emailRegex = /^[a-zA-Z0-9._%+\-&]+@[a-zA-Z0-9.-]+\.[A-Za-z]{2,}$/;
        const invalidEmails = emailArray.filter(email => !emailRegex.test(email));
        if (invalidEmails.length > 0) {
          return { invalidEmails: true };
        }
      }
      return null;
    };
  }
  whitespaceValidator() {
    return (control: FormControl) => {
      const value = control.value || ''; // Get the control value or set it to an empty string
      const strippedValue = value.replace(/<\/?[^>]+(>|$)/g, '').trim(); // Strip HTML tags and trim whitespace
  
      // If the stripped content is empty, return an error
      if (!strippedValue) {
        return { whitespace: true }; // Return error if it's all whitespace
      }
      return null; // No error if the content is valid
    };
  }
}
